

const Contact = () => {

    return(
        <div className="contact common-class">
            <h1>Contact</h1>
            <p>Email: <a href="mailto:diveshkkolhe@gmail.com">diveshkkolhe@gmail.com</a></p>
            <p>Phone: <a href="tel:7447758660">7447758660</a></p>
        </div>
    )
}


export default Contact;